import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArticleList from '../ArticleList';

function ArticlesTab({ currentSport }) {
	const navigate = useNavigate();

	const handleCategoryChange = (value) => {
		// If category changes and it's different from current sport, redirect with full page reload
		if (value && value !== currentSport) {
			let route = '';
			
			// Handle different sport routes
			switch(value.toUpperCase()) {
				case 'NFL':
					route = '/nfl/upcominggames?view=articles';
					break;
				case 'CFB':
					route = '/cfb/upcominggames?view=articles';
					break;
				case 'NBA':
					route = '/nba/upcominggames?view=articles';
					break;
				case 'IPL':
				case 'CRICKET':
					route = '/cricket/upcominggames?league=IPL&view=articles';
					break;
				case 'EPL':
					route = '/soccer/upcominggames?league=EPL&view=articles';
					break;
				case 'LA LIGA':
					route = '/soccer/upcominggames?league=ESP&view=articles';
					break;
				default:
					// Fallback for any other category
					route = `/articles`;
			}
			
			// Use window.location.href for full page reload to fetch all data (schedules, teams, players, etc.)
			window.location.href = route;
		}
	};

	return (
		<ArticleList 
			defaultCategory={currentSport || ''}
			showBanner={false}
			hideWrapper={true}
			onCategoryChange={handleCategoryChange}
		/>
	);
}

export default ArticlesTab;
